import React from "react";
import "./daysOnline.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const DaysOnline = () => {
  return (
    <>
      <div className="dopContainer">
        {" "}
        <div className="daysOnlinePage">
          <div className="daysOnline">
            <span>
              {" "}
              <i className="fas fa-signal"></i>
              <br />
              2282
            </span>
            Days Online
          </div>
          <div className="registeredUsers">
            <span>
              <i className="far fa-handshake"></i> <br />
              204008
            </span>{" "}
            Registered Users
          </div>
          <div className="currentDeposits">
            <span>
              <i class="fas fa-dollar-sign"></i> <br />
              $10572874
            </span>{" "}
            Current Deposits
          </div>
          <div className="totalWithdrawals">
            <span>
              <i class="fas fa-money-check-alt"></i> <br />
              $17211075.82
            </span>{" "}
            Total Withdrawals
          </div>
        </div>
      </div>
    </>
  );
};

export default DaysOnline;
